import CartOverlay from "@components/Cart/CartOverlay";
import classNames from "classnames";
import FavoritesOverlay from "@components/Favorites/FavoritesOverlay";
import PropTypes from "prop-types";
import React from "react";
import {
  CloseOutlined,
  MenuOutlined,
  ShoppingCartOutlined,
} from "@mui/icons-material";
import { Disclosure } from "@headlessui/react";
import { getAbsoluteImagePath } from "@utils/dom";
import { MenuArea, MenuCustomer } from "./index";
import { NavLink } from "react-router-dom";
import { routes } from "@routes";
import { showFavoritesEtab, showFavoritesProposal } from "@utils/favorites";
import { useSession } from "@hooks";

type NavbarProps = {
  //
};

const languagesVarsCodes = [
  "LANG_neobooking_open_menu", //Ouvrir le menu
  "LANG_neobooking_booking", //Réservation en ligne
  "LANG_neobooking_my_cart", //Mon panier
];

const Navbar: React.FC<NavbarProps> = () => {
  /* Hooks */
  const { getLanguageVarValue } = useSession();

  return (
    <>
      <Disclosure
        as="nav"
        className="tw-bg-gray-50 tw-backdrop-blur tw-bg-opacity-70 tw-h-18 tw-items-center tw-sticky tw-top-0 tw-shadow-sm"
        style={{ zIndex: "1001" }}
      >
        {({ open }) => (
          <>
            <div className="tw-container tw-mx-auto">
              <div className="tw-relative tw-flex tw-items-center tw-justify-between tw-h-16">
                <div className="tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center sm:tw-hidden">
                  {/* Mobile menu button*/}
                  <Disclosure.Button className="tw-inline-flex tw-items-center tw-justify-center tw-p-2 tw-rounded-md tw-text-dark-light hover:tw-text-dark-dark focus:tw-outline-none">
                    <span className="tw-sr-only">
                      {getLanguageVarValue("LANG_neobooking_open_menu")}
                    </span>
                    {open ? (
                      <CloseOutlined
                        fontSize="medium"
                        className="tw-block tw-h-6 tw-w-6 hover:tw-text-primary-500 tw-transition-colors tw-duration-200 tw-ease-in-out"
                        aria-hidden="true"
                      />
                    ) : (
                      <MenuOutlined
                        fontSize="medium"
                        className="tw-block tw-h-6 tw-w-6 hover:tw-text-primary-500 tw-transition-colors tw-duration-200 tw-ease-in-out"
                        aria-hidden="true"
                      />
                    )}
                  </Disclosure.Button>
                </div>
                <div>
                  <a
                    href={process.env.REACT_APP_CUSTOMER_URL!!}
                    target="_blank"
                  >
                    <img
                      className="tw-h-8 tw-w-auto"
                      src={getAbsoluteImagePath(
                        "/assets/img/customer/logo.png"
                      )}
                      alt="Logo"
                    />
                  </a>
                </div>
                <div className="tw-absolute tw-inset-y-0 tw-right-0 tw-items-center tw-gap-1 tw-hidden sm:tw-flex">
                  <NavLink
                    to={routes.home}
                    end
                    className={(navData) =>
                      classNames(
                        navData.isActive ? "tw-text-primary-500" : "",
                        "tw-text-sm tw-px-3 tw-py-2 tw-font-medium focus:tw-outline-none tw-cursor-pointer hover:tw-text-primary-500 tw-transition-colors tw-duration-200 tw-ease-in-out"
                      )
                    }
                  >
                    {getLanguageVarValue("LANG_neobooking_booking")}
                  </NavLink>
                  <MenuArea isMobile={false} end={false} />
                  <MenuCustomer />
                  {(showFavoritesEtab() || showFavoritesProposal()) && (
                    <FavoritesOverlay />
                  )}
                  <CartOverlay
                    btnElement={(onClick) => (
                      <button
                        onClick={onClick}
                        className="focus:tw-outline-none"
                      >
                        <div className="tw-h-6 tw-relative tw-ml-2">
                          <span className="tw-sr-only">Open cart menu</span>
                          <ShoppingCartOutlined
                            className="tw-block"
                            fontSize="medium"
                          />
                          <span className="tw-bg-red-500 tw-w-2 tw-h-2 tw-rounded-full tw-absolute tw--right-1 tw-top-0"></span>
                        </div>
                      </button>
                    )}
                  ></CartOverlay>
                </div>
              </div>
            </div>
            <Disclosure.Panel className="sm:tw-hidden">
              <div className="tw-px-2 tw-pt-2 tw-pb-3 tw-flex tw-flex-col tw-gap-2">
                <NavLink
                  to={routes.home}
                  end
                  className={(navData) =>
                    classNames(
                      navData.isActive
                        ? "tw-text-primary-500 tw-bg-gray-100"
                        : "",
                      "tw-py-2 tw-rounded tw-text-base tw-px-3 tw-font-medium focus:tw-outline-none tw-cursor-pointer hover:tw-text-primary-500 tw-transition-colors tw-duration-200 tw-ease-in-out"
                    )
                  }
                >
                  {getLanguageVarValue("LANG_neobooking_booking")}
                </NavLink>
                <MenuArea isMobile={true} end={true} />
                <NavLink
                  to={routes.reservation}
                  end
                  className={(navData) =>
                    classNames(
                      navData.isActive
                        ? "tw-text-primary-500 tw-bg-gray-100"
                        : "",
                      "tw-py-2 tw-rounded tw-text-base tw-px-3 tw-font-medium focus:tw-outline-none tw-cursor-pointer hover:tw-text-primary-500 tw-transition-colors tw-duration-200 tw-ease-in-out"
                    )
                  }
                >
                  {getLanguageVarValue("LANG_neobooking_my_cart")}
                </NavLink>
              </div>
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>
    </>
  );
};

Navbar.propTypes = {
  //
};

export default Navbar;
